import { render, staticRenderFns } from "./BiliBili.vue?vue&type=template&id=e8590870&scoped=true"
import script from "./BiliBili.vue?vue&type=script&lang=js"
export * from "./BiliBili.vue?vue&type=script&lang=js"
import style0 from "./BiliBili.vue?vue&type=style&index=0&id=e8590870&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8590870",
  null
  
)

export default component.exports